import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Truck, Loader } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DriverOnboarding = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    // Passwordless magic-link: exchange the invite token for a session, then
    // drop the driver straight onto their employment application.
    const autoLogin = async () => {
      try {
        await axios.post(
          `${API}/driver-invitations/auto-login`,
          { token },
          { withCredentials: true }
        );
        await checkAuth();
        if (active) navigate('/onboarding/application' + (window.location.hash || ''), { replace: true });
      } catch (err) {
        const detail = err.response?.data?.detail;
        if (active) setError(typeof detail === 'string' ? detail : 'Invalid or expired invitation link');
      }
    };
    autoLogin();
    return () => { active = false; };
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F2F4F7] p-4">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-md p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Truck className="w-8 h-8 text-red-600" strokeWidth={2} />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Work Sans, sans-serif' }}>Invalid Invitation</h1>
          <p data-testid="invalid-invitation-message" className="text-sm text-slate-600 mb-6" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="text-sm text-[#002FA7] hover:text-[#00247D] font-semibold"
            style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
          >
            Go to login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F2F4F7] p-4" data-testid="onboarding-signing-in">
      <div className="w-12 h-12 bg-[#002FA7] rounded-md flex items-center justify-center mb-4">
        <Truck className="w-7 h-7 text-white" strokeWidth={2} />
      </div>
      <Loader className="w-6 h-6 animate-spin text-[#002FA7] mb-3" />
      <p className="text-sm text-slate-600" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>Signing you in and opening your application…</p>
    </div>
  );
};

export default DriverOnboarding;
